import apiClient from './apiClient';

const getUrl = "https://api.ailsalyn.co.uk/v1/artworks";

class artworksApi {
    static getAll() {
        return apiClient.get(getUrl);
    }
}

export default artworksApi;



// WEBPACK FOOTER //
// ./src/apis/artworksApi.js